import React from 'react';

const Reusablehop_category_price_three = ({ img, titel }) => {
  return (
    <>
      <div className="hop_category_price_three_menu">
        <div className="hop_category_price_three_menu_inner">
          <div className="hop_category_price_three_menu_img">
            <img src={img} className="w-100" alt="" />
          </div>
          <div className="hop_category_price_three_menu_text">
            <h3> {titel}</h3>
            <ul>
              <li>
                <div className="hop_category_price_three_menu_text_icon">
                  <i className="fa-solid fa-star"></i>
                </div>
              </li>
              <li>
                <div className="hop_category_price_three_menu_text_icon">
                  <i className="fa-solid fa-star"></i>
                </div>
              </li>
              <li>
                <div className="hop_category_price_three_menu_text_icon">
                  <i className="fa-solid fa-star"></i>
                </div>
              </li>
              <li>
                <div className="hop_category_price_three_menu_text_icon">
                  <i className="fa-solid fa-star"></i>
                </div>
              </li>
              <li>
                <div className="hop_category_price_three_menu_text_icon">
                  <i className="fa-solid fa-star"></i>
                </div>
              </li>
            </ul>
            <p>$50 - $150</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reusablehop_category_price_three;
